// extracted by mini-css-extract-plugin
export default {"redMainLoader":"Loader_redMainLoader__bfvKz","redMainLoader-spin":"Loader_redMainLoader-spin__gmenx"};